import { z } from 'zod';

// Зеркалит Prisma-enum'ы из libs/prisma/schema.prisma. Любое расширение —
// сюда И в schema.prisma одновременно (тесты-rounder покрывают список).

export const CoinTxReasonSchema = z.enum([
  'REFERRAL_BONUS',
  'MANUAL_ADJUST',
  'ADVERT_POST',
  'PHOTO_TAG_BONUS',
  'MISSION_REWARD',
  'ENERGY_PURCHASE',
  'ORGANIZER_INVITE_BONUS',
  'ORGANIZER_WELCOME_BONUS',
  'SERVICE_PUBLISH',
  'SERVICE_PUBLISH_REFUND',
  'EVENT_PUBLISH',
  'EVENT_PUBLISH_REFUND',
  'PROMOTION_SOCIAL',
  'PROMOTION_SOCIAL_REFUND',
  'PROMOTION_MORNING_DIGEST',
  'PROMOTION_MORNING_DIGEST_REFUND',
  'NETWORKING_SWIPE',
  'MEETING_FEED',
  'ASSISTANT_REQUEST',
  'GAME_REQUEST',
  'LILO_REQUEST',
  'LILO_SESSION',
  'LILO_SESSION_REFUND',
  'WELCOME_BONUS',
  'COMPATIBILITY_REQUEST',
  'ASSISTANT_PERSON_REROLL',
  'PROMOTION_ADS',
  'PROMOTION_ADS_REFUND',
  'STATUS_ENERGY_GRANT',
  'RESERVATION_HOLD',
  'RESERVATION_PAYOUT',
  'RESERVATION_RELEASE',
]);
export type CoinTxReason = z.infer<typeof CoinTxReasonSchema>;

export const CoinTxStatusSchema = z.enum(['PENDING', 'POSTED', 'REVERTED']);
export type CoinTxStatus = z.infer<typeof CoinTxStatusSchema>;

// DTO одного «листа» admin-журнала транзакций.
// telegramId — BigInt в Prisma, в JSON всегда строка (см. CLAUDE.md, глобальный
// `BigInt.prototype.toJSON`). Поэтому здесь — `z.string().nullable()`.
export const CoinTransactionDtoSchema = z.object({
  id: z.uuid(),
  userId: z.uuid(),
  user: z.object({
    id: z.uuid(),
    username: z.string().nullable(),
    firstName: z.string().nullable(),
    telegramId: z.string().nullable(),
  }),
  delta: z.number().int(),
  balanceAfter: z.number().int().nullable(),
  reason: CoinTxReasonSchema,
  status: CoinTxStatusSchema,
  metadata: z.record(z.string(), z.unknown()).nullable(),
  idempotencyKey: z.string(),
  createdAt: z.iso.datetime(),
  postedAt: z.iso.datetime().nullable(),
});
export type CoinTransactionDto = z.infer<typeof CoinTransactionDtoSchema>;
